module.exports = __webpack_public_path__ + "img/lightInactive.645cc28a.svg";